import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
const headingSizeClass = {
    sm: 'text-[length:var(--fs-ui-title)]',
    ui: 'text-[length:var(--fs-ui-page-title)]',
    md: 'text-[length:var(--fs-h4)]',
    home: 'text-[length:var(--fs-ui-home-title)]',
    lg: 'text-[length:var(--fs-h3)]',
    xl: 'text-[length:var(--fs-h2)]'
};
const headingLineHeightClass = {
    sm: 'leading-[var(--lh-tight)]',
    ui: 'leading-[var(--lh-tight)]',
    md: 'leading-[var(--lh-tight)]',
    home: 'leading-[var(--lh-home)]',
    lg: 'leading-[var(--lh-tight)]',
    xl: 'leading-[var(--lh-tight)]'
};
/** Display-face heading with the canonical Specra tracking and weight. */ export const SpecraHeading = /*#__PURE__*/ React.forwardRef(({ as, className, level = 2, size = 'md', style, ...props }, ref)=>{
    const Component = as ?? `h${level}`;
    return /*#__PURE__*/ _jsx(Component, {
        className: cn('font-display font-medium tracking-[var(--ls-display)] text-foreground', headingSizeClass[size], headingLineHeightClass[size], className),
        ref: ref,
        style: style,
        ...props
    });
});
SpecraHeading.displayName = 'SpecraHeading';
const textSizeClass = {
    micro: 'text-[length:var(--fs-ui-micro)]',
    meta: 'text-[length:var(--fs-ui-meta)]',
    caption: 'text-[length:var(--fs-ui-caption)]',
    'body-ui': 'text-[length:var(--fs-ui-body)]',
    'body-sm': 'text-[length:var(--fs-ui)]',
    body: 'text-[length:var(--fs-body-sm)]'
};
const textToneClass = {
    primary: 'text-foreground',
    secondary: 'text-foreground/80',
    muted: 'text-muted-foreground',
    danger: 'text-danger',
    success: 'text-success',
    warning: 'text-warning',
    info: 'text-info'
};
/** Text-face primitive for product copy, metadata, and captions. */ export const SpecraText = /*#__PURE__*/ React.forwardRef(({ as: Component = 'span', className, size = 'body-sm', tone = 'primary', ...props }, ref)=>/*#__PURE__*/ _jsx(Component, {
        className: cn('leading-snug', textSizeClass[size], textToneClass[tone], className),
        ref: ref,
        ...props
    }));
SpecraText.displayName = 'SpecraText';
